var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerwavebg"},[_c('img',{attrs:{"src":("https://p3.udn.com.tw/wish/images/common/footer_" + (_vm.selectSrc_3('mob', 'pad', 'pc')) + ".svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }